import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=5df34df6&scoped=true&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=5df34df6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df34df6",
  null
  
)

export default component.exports